// Цвета заливки смайликов по уровню голода/сытости
const SMILEY_COLORS = {
  10: '#EFA6A6', 1: '#EFA6A6',
  9:  '#FAB291', 2: '#FAB291',
  8:  '#FFEDA5', 3: '#FFEDA5',
  7:  '#DEF3AA', 4: '#DEF3AA',
  6:  '#B0D780', 5: '#B0D780',
}

// Выражение лица по уровню
function getExpression(value) {
  if (value === 10 || value === 1) return 'sad'
  if (value === 9  || value === 2) return 'slightly_sad'
  if (value === 8  || value === 3) return 'neutral'
  if (value === 7  || value === 4) return 'slight_smile'
  return 'smile' // 6, 5
}

// Путь рта для каждого выражения
const MOUTH_PATHS = {
  sad:          '<path d="M11 23c1.5-2.5 3.5-3.5 5-3.5s3.5 1 5 3.5" stroke="#555" stroke-width="1.5" stroke-linecap="round" fill="none"/>',
  slightly_sad: '<path d="M11 22c1.5-1.8 3.5-2.5 5-2.5s3.5.7 5 2.5" stroke="#555" stroke-width="1.5" stroke-linecap="round" fill="none"/>',
  neutral:      '<line x1="11" y1="21" x2="21" y2="21" stroke="#555" stroke-width="1.5" stroke-linecap="round"/>',
  slight_smile: '<path d="M11 20c1.5 1.2 3.5 1.8 5 1.8s3.5-.6 5-1.8" stroke="#555" stroke-width="1.5" stroke-linecap="round" fill="none"/>',
  smile:        '<path d="M11 19c1.5 2.5 3.5 3.5 5 3.5s3.5-1 5-3.5" stroke="#555" stroke-width="1.5" stroke-linecap="round" fill="none"/>',
}

// Генерация SVG для смайлика (с цветной заливкой, без бровей)
export function getSmileyHtml(value, size = 32) {
  const color = SMILEY_COLORS[value] || '#E0E0E0'
  const expr = getExpression(value)
  const mouth = MOUTH_PATHS[expr]
  // Масштабируем viewBox 32 → size
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="14" fill="${color}" stroke="rgba(65,41,26,0.8)" stroke-width="1.5"/><circle cx="11" cy="13" r="1.5" fill="#555"/><circle cx="21" cy="13" r="1.5" fill="#555"/>${mouth}</svg>`
}

// Генерация серого смайлика по умолчанию (не выставлено значение)
export function getDefaultSmileyHtml(size = 20) {
  return `<svg width="${size}" height="${size}" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1"/><circle cx="7" cy="8.5" r="1" fill="currentColor"/><circle cx="13" cy="8.5" r="1" fill="currentColor"/><path d="M7 13c1 1.5 2.2 2 3 2s2-.5 3-2" stroke="currentColor" stroke-width="1" stroke-linecap="round" fill="none"/></svg>`
}

export { SMILEY_COLORS, getExpression }
